import { MAIN_PAGES } from '@libs/common/enums/main-pages';

export const AVAILABLE_MOBILE_PAGES = [
    MAIN_PAGES.default,
    MAIN_PAGES.indoor,
    MAIN_PAGES.indoorWidget,
    MAIN_PAGES.analytics,
];
